import React, { useEffect, useLayoutEffect, useState } from "react";

import { Box } from "@mui/material";

import DatePickerField from "./DatePickerField";

import styles from "./index.module.scss";

const DatePicker = ({
  dateRange,
  setDateRange,
  value = dateRange,
  onChange = setDateRange,
  withBox = true,
  fullWidth = false,
  resetButton = false,
  inputSx,
  ...props
}) => {
  const [openDateRange, setIsOpenDateRange] = useState(false);
  const [valueC, setValue] = useState(value);
  const onChangeDatePickerField = newDateRange => {
    setValue(newDateRange);
    // if (!openDateRange) onChange(newDateRange);
  };
  useLayoutEffect(() => {
    if (!openDateRange) {
      onChange(valueC);
    }
  }, [openDateRange]);

  const onReset = e => {
    e.stopPropagation();
    onChange([null, null]);
  };

  useEffect(() => {
    setValue(value);
  }, [value]);

  if (!withBox) {
    return (
      <DatePickerField
        {...{
          open: openDateRange,
          setIsOpen: setIsOpenDateRange,
          calculateLocal: true,
          onChange: onChangeDatePickerField,
          value: valueC,
          width: fullWidth ? "100%" : "auto",
          resetButton,
          onReset,
          inputSx,
          ...props,
        }}
      />
    );
  }
  return (
    <Box className={styles.wrapper}>
      <DatePickerField
        {...{
          open: openDateRange,
          setIsOpen: setIsOpenDateRange,
          calculateLocal: true,
          onChange: onChangeDatePickerField,
          value: valueC,
          width: fullWidth ? "100%" : "auto",
          resetButton,
          onReset,
          inputSx,
          ...props,
        }}
      />
    </Box>
  );
};

export default DatePicker;
